import type { EventCallback, Event } from '../types'

export class EventBus {
  private static instance: EventBus | null = null
  private readonly listeners: Map<string, EventCallback[]> = new Map()

  private constructor () {}

  public static getInstance (): EventBus {
    if (EventBus.instance === null) {
      EventBus.instance = new EventBus()
    }
    return EventBus.instance
  }

  public subscribe (event: Event, callback: EventCallback): void {
    const eventName = event.toString()
    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, [])
    }
    this.listeners.get(eventName).push(callback)
  }

  public publish (event: Event, data: any = null): void {
    const eventName = event.toString()
    if (this.listeners.has(eventName)) {
      this.listeners.get(eventName).forEach(callback => callback(data))
    }
  }
}
